<template>
    <div class="homepage-admin">
        <div class="vcore_row filter-sort-row">
            <div class="vcore_col--md--2 vcore_col--sm--3 vcore_col--xs--4">
                <div class="vcore_input-group">
                    <!--<i class="vcore_icon icon-search icon"></i> Icon should be added once vcore supports icons in input fields-->
                    <input
                            class="vcore_input filter-input"
                            type="text"
                            v-model="filter"
                            placeholder="filter"
                    >
                </div>
            </div>
            <div class="vcore_col--md--2 vcore_col--sm--3 vcore_col--xs--4">
                <select
                        class="sort-select"
                        id="sort"
                        v-model="sortBy"
                >
                    <option value="Newest">Sort By</option>
                    <option value="Oldest">Oldest</option>
                    <option value="Newest">Newest</option>
                    <option value="Alphabetical">Title</option>
                </select>
            </div>
        </div>
        <div class="vcore_row">
            <div
                    class="vcore_col--md--6 vcore_col--xl--4"
                    v-for="prototype in sortedPrototypeArray"
                    :key="prototype.path"
            >
                <ProjectCard
                        class="card-component"
                        :title="prototype.title"
                        :update="prototype.update"
                        :path="prototype.path"
                        :url="VUE_APP_URL"
                        :buttons="false"
                ></ProjectCard>
            </div>
        </div>
    </div>
</template>

<script>
    import ProjectCard from "../components/ProjectCard";
    import { mapActions, mapGetters } from "vuex";

    export default {
        name: "Homepage",
        components: {
            ProjectCard
        },
        data() {
            return {
                filter: "",
                sortBy: "Newest"
            }
        },
        computed: {
            ...mapGetters([
                "prototypeArray",
                "VUE_APP_URL"
            ]),
            filteredPrototypeArray: function() {
                // eslint-disable-next-line no-console
                console.log(this.prototypeArray)
                if (this.prototypeArray == []) {
                    return null;
                } else {
                    return this.prototypeArray.filter((prototype => {
                        return prototype.title.toLowerCase().includes(this.filter.toLowerCase());
                    }))
                }
            },
            sortedPrototypeArray: function() {
                if(this.filteredPrototypeArray == null){
                    return null;
                } else {
                    if(this.sortBy === ""){
                        return this.filteredPrototypeArray;
                    }
                    if(this.sortBy === "Oldest"){
                        return this.filteredPrototypeArray.slice(0).sort(function(a,b){
                            return a.update - b.update;
                        })
                    }
                    if(this.sortBy === "Newest"){
                        return this.filteredPrototypeArray.slice(0).sort(function(a,b){
                            return b.update - a.update;
                        })
                    }
                    if(this.sortBy === "Alphabetical"){
                        return this.filteredPrototypeArray.slice(0).sort(function(a,b){
                            return a.title.localeCompare(b.title);
                        })
                    }
                    return this.filteredPrototypeArray;
                }
            }
        },
        methods: {
            add() {
                this.$router.push({name: 'new'});
            },
            ...mapActions([
                "populateHomePage"
            ])
        },
        mounted() {
            this.$store.dispatch('populateHomePage');
            this.$store.dispatch('clearPrototype');
        }
    }
</script>

<style lang="scss" scoped>
    .homepage-admin {
        margin-top: 20px;
    }

    .filter-sort-row {
        margin-bottom: 10px;
    }

    .prototype-admin {
        width: 100%;
    }

    .sort-select {
        height: 40px;
        padding: 10px;
        line-height: 18px;
        width: 100%;
    }

    .title {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 36px;
        line-height: 49px;
        text-align: left;
        color: $color_black;
    }

    .left {
        float: left;
    }

    .filter-input {
        border-radius: 50px;
        margin-right: 10px;
    }

    .fp_container {
        background-color: rgba(255, 255, 255, 1);
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        border-top: 12px #2b78e4 solid;
        position: absolute;
        z-index: 5;
        top: 45%;
        left: 50%;
        transform: translate(-50%, -50%);
        padding: 30px;
        margin-bottom: 110px;
        width: 570px;
    }

    .fade-background{
        background-color: #000000;
        opacity: 50%;
        position: absolute;
        top:0px;
        left:0px;
        width: 100%;
        height: 100%;
    }

    .box-text {
        font-family: "Open Sans", sans-serif;
        font-style: normal;
        font-weight: normal;
        font-size: 18px;
        line-height: 24px;
        color: #666666;
        text-align: center;
        margin-bottom: 25px;
    }

    .modal-button {
        font-size: 18px;
        font-weight: 600;
        padding: 10px 30px;
        min-width: 150px;
        margin: 10px;
    }

    .card-component {
        margin: 10px 0px;
        min-width: 340px;
    }

    @media (max-width: 768px) {
        .card-component {
            margin: 20px 0px 25px;
        }
    }

</style>
